import { type Theme } from "@mui/material/styles";

export default function Autocomplete(theme: Theme) {
  return {
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          boxShadow: theme.customShadows.z4,
        },
      },
    },
    MuiListSubheader: {
      styleOverrides: {
        root: {
          fontWeight: 500,
          textTransform: "uppercase",
          fontSize: 12,
          lineHeight: theme.spacing(8),
          paddingLeft: theme.spacing(2),
          color: theme.palette.text.primary,
          top: "0px !important",
        },
      },
    },
  };
}
